module.exports = __webpack_public_path__ + "2ea27ba84b1cefb1cc928061c6f54494.webp";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/macha-main-420.webp
// module id = 458
// module chunks = 0